import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FadeUp } from "../components/Reveal";
import { FAQS } from "../lib/data";

export default function FAQ() {
  return (
    <main className="pt-40 pb-32" data-testid="faq-page">
      <div className="max-w-4xl mx-auto px-6">
        <FadeUp>
          <p className="font-mono-tech text-xs tracking-[0.3em] text-lime-400 uppercase mb-4">FAQ</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl text-zinc-50 leading-tight mb-6">
            Good questions, <span className="italic text-lime-300">honest answers.</span>
          </h1>
          <p className="text-zinc-400 max-w-xl text-base md:text-lg font-light leading-relaxed mb-16">
            The things people ask us most. Can't find yours? Send it through the booking form and we'll reply in person.
          </p>
        </FadeUp>

        <FadeUp delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
                <AccordionTrigger
                  className="text-left font-display text-lg md:text-xl text-zinc-100 hover:text-lime-300 hover:no-underline py-7 transition-colors duration-300"
                  data-testid={`faq-question-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 leading-relaxed text-base pb-7" data-testid={`faq-answer-${i}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>

        <FadeUp delay={0.15} className="mt-16">
          <Link
            to="/about#booking"
            data-testid="faq-book-cta"
            className="group inline-flex items-center gap-2 rounded-full bg-lime-400 text-black font-semibold px-8 py-4 transition-all duration-300 hover:bg-lime-300 hover:-translate-y-1"
          >
            Ask us directly
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </FadeUp>
      </div>
    </main>
  );
}
